import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { installStaleBuildRecovery } from '@rammetec/app-kit/errors'
import '@rammetec/design-system/styles.css' // MUST be first — design-system CSS tokens
import './index.css' // Tailwind directives
import './services/i18n.bootstrap'
import { bootstrapDataAccess } from './services/data-access.bootstrap'
import { App } from './app/App'
import { STALE_BUILD_OPTIONS } from '@/shared/errors/staleBuildOptions'

bootstrapDataAccess()
installStaleBuildRecovery(STALE_BUILD_OPTIONS)

const root = document.getElementById('root')
if (!root) throw new Error('Root element #root not found.')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
